import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDeviceId } from "src/helper/SerialNumberProvider";
import useDeviceTelemetries from "src/services/device/common/useDeviceTelemetries";

export const RadarFix = ({ className, size }) => {
  return (
    <svg
      width={`${size}em`}
      height={`${size}em`}
      viewBox="0 0 190 190"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <radialGradient
          cx="50%"
          cy="50%"
          fx="50%"
          fy="50%"
          r="50%"
          gradientTransform="translate(0.500000,0.500000),rotate(90.000000),scale(1.000000,1.043203),translate(-0.500000,-0.500000)"
          id="radialGradient-rf"
        >
          <stop stopColor="#000000" stopOpacity="0.8" offset="0%"></stop>
          <stop
            stopColor="#C1C1C1"
            stopOpacity="0.267182037"
            offset="33.2108651%"
          ></stop>
          <stop
            stopColor="#DBDBDB"
            stopOpacity="0.383659309"
            offset="68.903659%"
          ></stop>
          <stop stopColor="#FFFFFF" stopOpacity="0" offset="99.9076225%"></stop>
        </radialGradient>
        <circle id="path-2" cx="99" cy="99" r="75"></circle>
        <mask
          id="mask-3"
          maskContentUnits="userSpaceOnUse"
          maskUnits="objectBoundingBox"
          x="0"
          y="0"
          width="150"
          height="150"
          fill="white"
        >
          <use xlinkHref="#path-2"></use>
        </mask>
      </defs>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Artboard" transform="translate(-882.000000, -854.000000)">
          <g id="radar" transform="translate(848.000000, 820.000000)">
            <g id="fix-part" transform="translate(31.000000, 31.000000)">
              <g id="Group">
                <circle
                  id="outer"
                  stroke="#FF0000"
                  fillOpacity="0.700458"
                  fill="#000000"
                  cx="99"
                  cy="99"
                  r="95"
                ></circle>
                <circle
                  id="inner2"
                  stroke="#656565"
                  strokeWidth="0.5"
                  cx="99"
                  cy="99"
                  r="75"
                ></circle>
                <circle
                  id="inner1"
                  stroke="#626262"
                  strokeWidth="0.5"
                  cx="99"
                  cy="99"
                  r="50"
                ></circle>
                <circle
                  id="inner0"
                  stroke="#D7D7D7"
                  strokeWidth="0.1"
                  cx="99"
                  cy="99"
                  r="25"
                ></circle>
                <use
                  id="gradient"
                  stroke="url(#radialGradient-rf)"
                  mask="url(#mask-3)"
                  strokeWidth="150"
                  fillOpacity="0.347118"
                  fill="#000000"
                  strokeDasharray="59"
                  transform="translate(99.000000, 99.000000) rotate(67) translate(-99.000000, -99.000000) "
                  xlinkHref="#path-2"
                ></use>
              </g>
              <image
                id="cursor"
                x="86"
                y="87"
                width="26"
                height="25"
                xlinkHref="data:image/png;base64,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"
              ></image>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const RadarDegrees = ({ className, current, size, time }) => {
  return (
    <svg
      className={className}
      style={{
        transform: `rotate(${current}deg)`,
        transition: `transform .${time}s`,
        transformOrigin: "center",
      }}
      width={`${size}em`}
      height={`${size}em`}
      viewBox={`0 0 190 190`}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Artboard" transform="translate(-1.000000, -21.000000)">
          <g id="radar" transform="translate(-34.000000, -14.000000)">
            <g id="degrees">
              <g id="Combined-Shape" stroke="#FFFFFF">
                <path d="M220.628961,129.862416 L225,129.862416 L220.628961,129.862416 C220.628939,129.862416 220.628939,129.862416 220.628939,129.862416 Z M129.862416,39.6269805 L129.862416,35 L129.862416,39.6269805 C129.862416,39.6269805 129.862416,39.6269805 129.862416,39.6269805 Z M40.629558,129.862416 C40.629558,129.862416 40.629558,129.862416 40.629558,129.862416 L35,129.862416 L40.629558,129.862416 Z M129.862416,219.620583 L129.862416,225 L129.862416,219.620583 C129.862416,219.620583 129.862416,219.620583 129.862416,219.620583 Z"></path>
                <path
                  d="M220.628961,129.862416 L225,129.862416 L220.628961,129.862416 C220.628939,129.862416 220.628939,129.862416 220.628939,129.862416 Z M129.862416,39.6269805 L129.862416,35 L129.862416,39.6269805 C129.862416,39.6269805 129.862416,39.6269805 129.862416,39.6269805 Z M40.629558,129.862416 C40.629558,129.862416 40.629558,129.862416 40.629558,129.862416 L35,129.862416 L40.629558,129.862416 Z M129.862416,219.620583 L129.862416,225 L129.862416,219.620583 C129.862416,219.620583 129.862416,219.620583 129.862416,219.620583 Z"
                  transform="translate(130.000000, 130.000000) rotate(30.000000) translate(-130.000000, -130.000000) "
                ></path>
                <path
                  d="M220.628961,129.862416 L225,129.862416 L220.628961,129.862416 C220.628939,129.862416 220.628939,129.862416 220.628939,129.862416 Z M129.862416,39.6269805 L129.862416,35 L129.862416,39.6269805 C129.862416,39.6269805 129.862416,39.6269805 129.862416,39.6269805 Z M40.629558,129.862416 C40.629558,129.862416 40.629558,129.862416 40.629558,129.862416 L35,129.862416 L40.629558,129.862416 Z M129.862416,219.620583 L129.862416,225 L129.862416,219.620583 C129.862416,219.620583 129.862416,219.620583 129.862416,219.620583 Z"
                  transform="translate(130.000000, 130.000000) rotate(60.000000) translate(-130.000000, -130.000000) "
                ></path>
              </g>
              <text
                id="30"
                transform="translate(170.750000, 59.066987) rotate(30.000000) translate(-170.750000, -59.066987) "
                fontFamily="Roboto-Regular, Roboto"
                fontSize="12"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="164.011719" y="63.0669873">
                  30
                </tspan>
              </text>
              <text
                id="60"
                transform="translate(200.562178, 88.562178) rotate(60.000000) translate(-200.562178, -88.562178) "
                fontFamily="Roboto-Regular, Roboto"
                fontSize="12"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="193.823897" y="92.5621778">
                  60
                </tspan>
              </text>
              <text
                id="120"
                transform="translate(202.312178, 171.593267) rotate(120.000000) translate(-202.312178, -171.593267) "
                fontFamily="Roboto-Regular, Roboto"
                fontSize="12"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="192.204756" y="175.593267">
                  120
                </tspan>
              </text>
              <text
                id="150"
                transform="translate(173.593267, 200.312178) rotate(150.000000) translate(-173.593267, -200.312178) "
                fontFamily="Roboto-Regular, Roboto"
                fontSize="12"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="163.485845" y="204.312178">
                  150
                </tspan>
              </text>
              <text
                id="210"
                transform="translate(89.593267, 200.312178) rotate(210.000000) translate(-89.593267, -200.312178) "
                fontFamily="Roboto-Regular, Roboto"
                fontSize="12"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="79.4858449" y="204.312178">
                  210
                </tspan>
              </text>
              <text
                id="240"
                transform="translate(59.312178, 171.593267) rotate(240.000000) translate(-59.312178, -171.593267) "
                fontFamily="Roboto-Regular, Roboto"
                fontSize="12"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="49.204756" y="175.593267">
                  240
                </tspan>
              </text>
              <text
                id="300"
                transform="translate(59.312178, 88.593267) rotate(300.000000) translate(-59.312178, -88.593267) "
                fontFamily="Roboto-Regular, Roboto"
                fontSize="12"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="49.204756" y="92.5932667">
                  300
                </tspan>
              </text>
              <text
                id="330"
                transform="translate(89.593267, 57.312178) rotate(330.000000) translate(-89.593267, -57.312178) "
                fontFamily="Roboto-Regular, Roboto"
                fontSize="12"
                fontWeight="normal"
                fill="#FFFFFF"
              >
                <tspan x="79.4858449" y="61.3121778">
                  330
                </tspan>
              </text>
              <g id="directions" transform="translate(42.000000, 41.000000)">
                <g id="North" transform="translate(81.000000, 0.000000)">
                  <circle id="Oval" fill="#FFFFFF" cx="7" cy="7" r="7"></circle>
                  <text
                    id="N"
                    fontFamily="IRANSansWeb-Bold, IRANSansWeb"
                    fontSize="10"
                    fontWeight="bold"
                    fill="#000000"
                  >
                    <tspan x="3.19565217" y="10">
                      N
                    </tspan>
                  </text>
                </g>
                <g
                  id="E"
                  transform="translate(168.000000, 81.000000)"
                  fill="#FFFFFF"
                  fontFamily="IRANSansWeb-Bold, IRANSansWeb"
                  fontSize="10"
                  fontWeight="bold"
                >
                  <text>
                    <tspan x="1.9673913" y="10">
                      E
                    </tspan>
                  </text>
                </g>
                <g
                  id="E"
                  transform="translate(83.000000, 165.000000)"
                  fill="#FFFFFF"
                  fontFamily="IRANSansWeb-Bold, IRANSansWeb"
                  fontSize="10"
                  fontWeight="bold"
                >
                  <text id="S">
                    <tspan x="1.68695652" y="10">
                      S
                    </tspan>
                  </text>
                </g>
                <g
                  id="E"
                  transform="translate(0.000000, 81.000000)"
                  fill="#FFFFFF"
                  fontFamily="IRANSansWeb-Bold, IRANSansWeb"
                  fontSize="10"
                  fontWeight="bold"
                >
                  <text id="W">
                    <tspan x="0.286956522" y="10">
                      W
                    </tspan>
                  </text>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const RadarCurrent = ({ className, current }) => {
  return (
    <svg
      className={className}
      width="20px"
      height="18px"
      viewBox="0 0 20 18"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Artboard" transform="translate(-86.000000, 0.000000)">
          <g id="current" transform="translate(85.000000, -2.000000)">
            <polygon
              id="Triangle"
              fill="#F90000"
              transform="translate(11.000000, 17.000000) rotate(180.000000) translate(-11.000000, -17.000000) "
              points="11 12 21 22 1 22"
            ></polygon>
            <text
              id="120"
              fontFamily="Roboto-Regular, Roboto"
              fontSize="12"
              fontWeight="normal"
              fill="#FFFFFF"
            >
              <tspan x="0.392578125" y="11">
                {current}
              </tspan>
            </text>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const RadarFacing = ({ className, heading, size, time }) => {
  const [facing, setFacing] = useState(0);
  const deviceId = useDeviceId();
  const telemetries = useDeviceTelemetries(deviceId);

  useEffect(() => {
    setFacing(Math.round(telemetries?.gimbalAngles?.z));
  }, [telemetries?.gimbalAngles]);

  return (
    <svg
      className={className}
      style={{
        transform: `rotate(${facing - heading}deg)`,
        transition: `transform ${time}s`,
        transformOrigin: "center",
      }}
      width={`${size}em`}
      height={`${size}em`}
      viewBox="0 0 190 190"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <linearGradient
          x1="50%"
          y1="0%"
          x2="50%"
          y2="100%"
          id="linearGradient-1"
        >
          <stop stopColor="#FFFD00" offset="0%"></stop>
          <stop stopColor="#FFFD00" offset="48.9404255%"></stop>
          <stop stopColor="#D8D8D8" stopOpacity="0" offset="100%"></stop>
        </linearGradient>
      </defs>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Artboard" transform="translate(-1.000000, -20.000000)">
          <g
            id="facing"
            transform="translate(96.000000, 115.000000) translate(-96.000000, -115.000000) translate(1.000000, 20.000000)"
          >
            <circle
              id="outer"
              fillOpacity="0.1"
              fill="#000000"
              cx="95"
              cy="95"
              r="95"
            ></circle>
            <polygon
              id="Triangle"
              fill="url(#linearGradient-1)"
              transform="translate(95.500000, 10.000000) scale(1, -1) translate(-95.500000, -10.000000) "
              points="95.5 2.84217094e-14 106 20 85 20"
            ></polygon>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const JoyHandle = ({ className, current, size }) => {
  return (
    <svg
      width={`${size}em`}
      height={`${size}em`}
      viewBox="0 0 64 64"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <radialGradient
          cx="38.3633308%"
          cy="33.8099415%"
          fx="38.3633308%"
          fy="33.8099415%"
          r="59%"
          id="radialGradient-jh"
        >
          <stop stopColor="#FFFFFF" offset="0%"></stop>
          <stop stopColor="#F50000" offset="29.39981%"></stop>
          <stop stopColor="#C91616" offset="58.4%"></stop>
          <stop stopColor="#5F0A0A" offset="100%"></stop>
        </radialGradient>
        <circle id="path-2" cx="32" cy="32" r="32"></circle>
        <filter
          x="-16.4%"
          y="-16.4%"
          width="132.8%"
          height="132.8%"
          filterUnits="objectBoundingBox"
          id="filter-3"
        >
          <feMorphology
            radius="0.5"
            operator="dilate"
            in="SourceAlpha"
            result="shadowSpreadOuter1"
          ></feMorphology>
          <feOffset
            dx="0"
            dy="0"
            in="shadowSpreadOuter1"
            result="shadowOffsetOuter1"
          ></feOffset>
          <feGaussianBlur
            stdDeviation="3"
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          ></feGaussianBlur>
          <feComposite
            in="shadowBlurOuter1"
            in2="SourceAlpha"
            operator="out"
            result="shadowBlurOuter1"
          ></feComposite>
          <feColorMatrix
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.69798951 0"
            type="matrix"
            in="shadowBlurOuter1"
          ></feColorMatrix>
        </filter>
      </defs>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Artboard"
          transform="translate(-764.000000, -911.000000)"
          fillRule="nonzero"
        >
          <g id="joy-handle" transform="translate(771.000000, 918.000000)">
            <g id="Oval">
              <use
                fill="black"
                fillOpacity="1"
                filter="url(#filter-3)"
                xlinkHref="#path-2"
              ></use>
              <use
                fillOpacity="0.85"
                fill="url(#radialGradient-jh)"
                xlinkHref="#path-2"
              ></use>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const JoyPY = ({ className, current, size }) => {
  return (
    <svg
      width={`${size}em`}
      height={`${size}em`}
      viewBox="0 0 128 128"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <radialGradient
          cx="50%"
          cy="50%"
          fx="50%"
          fy="50%"
          r="76.409007%"
          id="radialGradient-jpy"
        >
          <stop stopColor="#EEEEEE" stopOpacity="0.65357299" offset="0%"></stop>
          <stop
            stopColor="#F1F1F1"
            stopOpacity="0.415018575"
            offset="29.7148944%"
          ></stop>
          <stop
            stopColor="#FFFFFF"
            stopOpacity="0.490937837"
            offset="34.0273013%"
          ></stop>
          <stop
            stopColor="#E4E2E2"
            stopOpacity="0.52269492"
            offset="36.6506956%"
          ></stop>
          <stop
            stopColor="#E7E7E7"
            stopOpacity="0.578003694"
            offset="55.210401%"
          ></stop>
          <stop
            stopColor="#A3A3A3"
            stopOpacity="0.557444807"
            offset="64.0193725%"
          ></stop>
          <stop
            stopColor="#FFFFFF"
            stopOpacity="0.52534965"
            offset="100%"
          ></stop>
        </radialGradient>
      </defs>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Artboard" transform="translate(-739.000000, -886.000000)">
          <g id="joy-PY" transform="translate(739.000000, 886.000000)">
            <g id="joystick">
              <circle
                id="Oval"
                fillOpacity="0.7"
                fill="#000000"
                cx="64"
                cy="64"
                r="64"
              ></circle>
              <circle
                id="Oval"
                fill="url(#radialGradient-jpy)"
                cx="64"
                cy="64"
                r="45.7142857"
              ></circle>
              <circle
                id="Oval"
                stroke="#F4F3F3"
                strokeWidth="0.2"
                cx="63.7714286"
                cy="63.7714286"
                r="23.7714286"
              ></circle>
              <circle id="Oval" cx="64" cy="64" r="38"></circle>
            </g>
            <g
              id="direction"
              transform="translate(111.000000, 55.000000)"
              fill="#FFFFFF"
              fontFamily="PTSerif-Caption, PT Serif Caption"
              fontSize="10"
              fontWeight="normal"
            >
              <text id="+P">
                <tspan x="0.165" y="10">
                  +Y
                </tspan>
              </text>
            </g>
            <g
              id="direction"
              transform="translate(58.000000, 112.000000)"
              fill="#FFFFFF"
              fontFamily="PTSerif-Caption, PT Serif Caption"
              fontSize="10"
              fontWeight="normal"
            >
              <text id="+P">
                <tspan x="0.49" y="10">
                  -P
                </tspan>
              </text>
            </g>
            <g
              id="direction"
              transform="translate(58.000000, 3.000000)"
              fill="#FFFFFF"
              fontFamily="PTSerif-Caption, PT Serif Caption"
              fontSize="10"
              fontWeight="normal"
            >
              <text id="+P">
                <tspan x="-0.135" y="10">
                  +P
                </tspan>
              </text>
            </g>
            <g
              id="direction"
              transform="translate(2.000000, 55.000000)"
              fill="#FFFFFF"
              fontFamily="PTSerif-Caption, PT Serif Caption"
              fontSize="10"
              fontWeight="normal"
            >
              <text id="+P">
                <tspan x="0.79" y="10">
                  -Y
                </tspan>
              </text>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const JoyRoll = ({ className, current, size }) => {
  return (
    <svg
      width={`${size}em`}
      height={`${size}em`}
      viewBox="0 0 128 128"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <radialGradient
          cx="50%"
          cy="50%"
          fx="50%"
          fy="50%"
          r="76.409007%"
          id="radialGradient-jr"
        >
          <stop stopColor="#EEEEEE" stopOpacity="0.65357299" offset="0%"></stop>
          <stop
            stopColor="#F1F1F1"
            stopOpacity="0.415018575"
            offset="29.7148944%"
          ></stop>
          <stop
            stopColor="#FFFFFF"
            stopOpacity="0.490937837"
            offset="34.0273013%"
          ></stop>
          <stop
            stopColor="#E4E2E2"
            stopOpacity="0.52269492"
            offset="36.6506956%"
          ></stop>
          <stop
            stopColor="#E7E7E7"
            stopOpacity="0.578003694"
            offset="55.210401%"
          ></stop>
          <stop
            stopColor="#A3A3A3"
            stopOpacity="0.557444807"
            offset="64.0193725%"
          ></stop>
          <stop
            stopColor="#FFFFFF"
            stopOpacity="0.52534965"
            offset="100%"
          ></stop>
        </radialGradient>
      </defs>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Artboard" transform="translate(-739.000000, -886.000000)">
          <g id="joy-PY" transform="translate(739.000000, 886.000000)">
            <g id="joystick">
              <circle
                id="Oval"
                fillOpacity="0.7"
                fill="#000000"
                cx="64"
                cy="64"
                r="64"
              ></circle>
              <circle
                id="Oval"
                fill="url(#radialGradient-jr)"
                cx="64"
                cy="64"
                r="45.7142857"
              ></circle>
              <circle
                id="Oval"
                stroke="#F4F3F3"
                strokeWidth="0.2"
                cx="63.7714286"
                cy="63.7714286"
                r="23.7714286"
              ></circle>
              <circle id="Oval" cx="64" cy="64" r="38"></circle>
            </g>
            <g
              id="direction"
              transform="translate(111.000000, 55.000000)"
              fill="#FFFFFF"
              fontFamily="PTSerif-Caption, PT Serif Caption"
              fontSize="10"
              fontWeight="normal"
            >
              <text id="+P">
                <tspan x="-0.04" y="10">
                  +R
                </tspan>
              </text>
            </g>
            <g
              id="direction"
              transform="translate(2.000000, 55.000000)"
              fill="#FFFFFF"
              fontFamily="PTSerif-Caption, PT Serif Caption"
              fontSize="10"
              fontWeight="normal"
            >
              <text id="+P">
                <tspan x="0.585" y="10">
                  -R
                </tspan>
              </text>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const GimbalPlate = ({ name, className, current, size, directions }) => {
  return (
    <svg
      width="185px"
      height="185px"
      viewBox="0 0 185 185"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <circle id="path-1" cx="88.5" cy="88.5" r="87.5"></circle>
        <filter
          x="-4.3%"
          y="-4.3%"
          width="108.6%"
          height="108.6%"
          filterUnits="objectBoundingBox"
          id="filter-2"
        >
          <feMorphology
            radius="1"
            operator="dilate"
            in="SourceAlpha"
            result="shadowSpreadOuter1"
          ></feMorphology>
          <feOffset
            dx="0"
            dy="0"
            in="shadowSpreadOuter1"
            result="shadowOffsetOuter1"
          ></feOffset>
          <feMorphology
            radius="1.5"
            operator="erode"
            in="SourceAlpha"
            result="shadowInner"
          ></feMorphology>
          <feOffset
            dx="0"
            dy="0"
            in="shadowInner"
            result="shadowInner"
          ></feOffset>
          <feComposite
            in="shadowOffsetOuter1"
            in2="shadowInner"
            operator="out"
            result="shadowOffsetOuter1"
          ></feComposite>
          <feGaussianBlur
            stdDeviation="2"
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          ></feGaussianBlur>
          <feColorMatrix
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0"
            type="matrix"
            in="shadowBlurOuter1"
          ></feColorMatrix>
        </filter>
        <radialGradient
          cx="50%"
          cy="50%"
          fx="50%"
          fy="50%"
          r="50%"
          gradientTransform="translate(0.500000,0.500000),rotate(90.000000),scale(1.000000,0.999844),translate(-0.500000,-0.500000)"
          id="radialGradient-3"
        >
          <stop
            stopColor="#BBBBBB"
            stopOpacity="0.299087631"
            offset="0%"
          ></stop>
          <stop
            stopColor="#E7E7E7"
            stopOpacity="0.410340189"
            offset="0%"
          ></stop>
          <stop
            stopColor="#ECECEC"
            stopOpacity="0.423377404"
            offset="74.6983711%"
          ></stop>
          <stop stopColor="#FFFFFF" offset="87.0352733%"></stop>
          <stop stopColor="#717171" offset="100%"></stop>
        </radialGradient>
        <path
          d="M173.369922,89.5 L179,89.5 L173.369922,89.5 C173.369922,89.5 173.369922,89.5 173.369922,89.5 Z M89.5,6.37702403 C89.5,6.37702403 89.5,6.37702403 89.5,6.37702403 L89.5,9.9475983e-14 L89.5,6.37702403 Z M6.37158125,89.5 L2.84217094e-14,89.5 L6.37158125,89.5 C6.37158125,89.5 6.37158125,89.5 6.37158125,89.5 Z M89.5,173.375413 L89.5,179 L89.5,173.375413 C89.5,173.375413 89.5,173.375413 89.5,173.375413 Z"
          id="path-4"
        ></path>
        <filter
          x="-1.4%"
          y="-1.4%"
          width="102.8%"
          height="102.8%"
          filterUnits="objectBoundingBox"
          id="filter-5"
        >
          <feMorphology
            radius="1"
            operator="dilate"
            in="SourceAlpha"
            result="shadowSpreadOuter1"
          ></feMorphology>
          <feOffset
            dx="0"
            dy="0"
            in="shadowSpreadOuter1"
            result="shadowOffsetOuter1"
          ></feOffset>
          <feMorphology
            radius="1"
            operator="erode"
            in="SourceAlpha"
            result="shadowInner"
          ></feMorphology>
          <feOffset
            dx="0"
            dy="0"
            in="shadowInner"
            result="shadowInner"
          ></feOffset>
          <feComposite
            in="shadowOffsetOuter1"
            in2="shadowInner"
            operator="out"
            result="shadowOffsetOuter1"
          ></feComposite>
          <feGaussianBlur
            stdDeviation="0.5"
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          ></feGaussianBlur>
          <feColorMatrix
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.91643903 0"
            type="matrix"
            in="shadowBlurOuter1"
          ></feColorMatrix>
        </filter>
        <path
          d="M173.369922,89.5 L179,89.5 L173.369922,89.5 C173.369922,89.5 173.369922,89.5 173.369922,89.5 Z M89.5,6.37702403 C89.5,6.37702403 89.5,6.37702403 89.5,6.37702403 L89.5,9.9475983e-14 L89.5,6.37702403 Z M6.37158125,89.5 L2.84217094e-14,89.5 L6.37158125,89.5 C6.37158125,89.5 6.37158125,89.5 6.37158125,89.5 Z M89.5,173.375413 L89.5,179 L89.5,173.375413 C89.5,173.375413 89.5,173.375413 89.5,173.375413 Z"
          id="path-6"
        ></path>
        <filter
          x="-1.4%"
          y="-1.4%"
          width="102.8%"
          height="102.8%"
          filterUnits="objectBoundingBox"
          id="filter-7"
        >
          <feMorphology
            radius="1"
            operator="dilate"
            in="SourceAlpha"
            result="shadowSpreadOuter1"
          ></feMorphology>
          <feOffset
            dx="0"
            dy="0"
            in="shadowSpreadOuter1"
            result="shadowOffsetOuter1"
          ></feOffset>
          <feMorphology
            radius="1"
            operator="erode"
            in="SourceAlpha"
            result="shadowInner"
          ></feMorphology>
          <feOffset
            dx="0"
            dy="0"
            in="shadowInner"
            result="shadowInner"
          ></feOffset>
          <feComposite
            in="shadowOffsetOuter1"
            in2="shadowInner"
            operator="out"
            result="shadowOffsetOuter1"
          ></feComposite>
          <feGaussianBlur
            stdDeviation="0.5"
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          ></feGaussianBlur>
          <feColorMatrix
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.91643903 0"
            type="matrix"
            in="shadowBlurOuter1"
          ></feColorMatrix>
        </filter>
        <path
          d="M173.369922,89.5 L179,89.5 L173.369922,89.5 C173.369922,89.5 173.369922,89.5 173.369922,89.5 Z M89.5,6.37702403 C89.5,6.37702403 89.5,6.37702403 89.5,6.37702403 L89.5,9.9475983e-14 L89.5,6.37702403 Z M6.37158125,89.5 L2.84217094e-14,89.5 L6.37158125,89.5 C6.37158125,89.5 6.37158125,89.5 6.37158125,89.5 Z M89.5,173.375413 L89.5,179 L89.5,173.375413 C89.5,173.375413 89.5,173.375413 89.5,173.375413 Z"
          id="path-8"
        ></path>
        <filter
          x="-1.4%"
          y="-1.4%"
          width="102.8%"
          height="102.8%"
          filterUnits="objectBoundingBox"
          id="filter-9"
        >
          <feMorphology
            radius="1"
            operator="dilate"
            in="SourceAlpha"
            result="shadowSpreadOuter1"
          ></feMorphology>
          <feOffset
            dx="0"
            dy="0"
            in="shadowSpreadOuter1"
            result="shadowOffsetOuter1"
          ></feOffset>
          <feMorphology
            radius="1"
            operator="erode"
            in="SourceAlpha"
            result="shadowInner"
          ></feMorphology>
          <feOffset
            dx="0"
            dy="0"
            in="shadowInner"
            result="shadowInner"
          ></feOffset>
          <feComposite
            in="shadowOffsetOuter1"
            in2="shadowInner"
            operator="out"
            result="shadowOffsetOuter1"
          ></feComposite>
          <feGaussianBlur
            stdDeviation="0.5"
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          ></feGaussianBlur>
          <feColorMatrix
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.91643903 0"
            type="matrix"
            in="shadowBlurOuter1"
          ></feColorMatrix>
        </filter>
        <path
          d="M173.369922,89.5 L179,89.5 L173.369922,89.5 C173.369922,89.5 173.369922,89.5 173.369922,89.5 Z M89.5,6.37702403 C89.5,6.37702403 89.5,6.37702403 89.5,6.37702403 L89.5,9.9475983e-14 L89.5,6.37702403 Z M6.37158125,89.5 L2.84217094e-14,89.5 L6.37158125,89.5 C6.37158125,89.5 6.37158125,89.5 6.37158125,89.5 Z M89.5,173.375413 L89.5,179 L89.5,173.375413 C89.5,173.375413 89.5,173.375413 89.5,173.375413 Z"
          id="path-10"
        ></path>
        <filter
          x="-1.4%"
          y="-1.4%"
          width="102.8%"
          height="102.8%"
          filterUnits="objectBoundingBox"
          id="filter-11"
        >
          <feMorphology
            radius="1"
            operator="dilate"
            in="SourceAlpha"
            result="shadowSpreadOuter1"
          ></feMorphology>
          <feOffset
            dx="0"
            dy="0"
            in="shadowSpreadOuter1"
            result="shadowOffsetOuter1"
          ></feOffset>
          <feMorphology
            radius="1"
            operator="erode"
            in="SourceAlpha"
            result="shadowInner"
          ></feMorphology>
          <feOffset
            dx="0"
            dy="0"
            in="shadowInner"
            result="shadowInner"
          ></feOffset>
          <feComposite
            in="shadowOffsetOuter1"
            in2="shadowInner"
            operator="out"
            result="shadowOffsetOuter1"
          ></feComposite>
          <feGaussianBlur
            stdDeviation="0.5"
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          ></feGaussianBlur>
          <feColorMatrix
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.91643903 0"
            type="matrix"
            in="shadowBlurOuter1"
          ></feColorMatrix>
        </filter>
        <path
          d="M173.369922,89.5 L179,89.5 L173.369922,89.5 C173.369922,89.5 173.369922,89.5 173.369922,89.5 Z M89.5,6.37702403 C89.5,6.37702403 89.5,6.37702403 89.5,6.37702403 L89.5,9.9475983e-14 L89.5,6.37702403 Z M6.37158125,89.5 L2.84217094e-14,89.5 L6.37158125,89.5 C6.37158125,89.5 6.37158125,89.5 6.37158125,89.5 Z M89.5,173.375413 L89.5,179 L89.5,173.375413 C89.5,173.375413 89.5,173.375413 89.5,173.375413 Z"
          id="path-12"
        ></path>
        <filter
          x="-1.4%"
          y="-1.4%"
          width="102.8%"
          height="102.8%"
          filterUnits="objectBoundingBox"
          id="filter-13"
        >
          <feMorphology
            radius="1"
            operator="dilate"
            in="SourceAlpha"
            result="shadowSpreadOuter1"
          ></feMorphology>
          <feOffset
            dx="0"
            dy="0"
            in="shadowSpreadOuter1"
            result="shadowOffsetOuter1"
          ></feOffset>
          <feMorphology
            radius="1"
            operator="erode"
            in="SourceAlpha"
            result="shadowInner"
          ></feMorphology>
          <feOffset
            dx="0"
            dy="0"
            in="shadowInner"
            result="shadowInner"
          ></feOffset>
          <feComposite
            in="shadowOffsetOuter1"
            in2="shadowInner"
            operator="out"
            result="shadowOffsetOuter1"
          ></feComposite>
          <feGaussianBlur
            stdDeviation="0.5"
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          ></feGaussianBlur>
          <feColorMatrix
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.91643903 0"
            type="matrix"
            in="shadowBlurOuter1"
          ></feColorMatrix>
        </filter>
        <path
          d="M173.369922,89.5 L179,89.5 L173.369922,89.5 C173.369922,89.5 173.369922,89.5 173.369922,89.5 Z M89.5,6.37702403 C89.5,6.37702403 89.5,6.37702403 89.5,6.37702403 L89.5,9.9475983e-14 L89.5,6.37702403 Z M6.37158125,89.5 L2.84217094e-14,89.5 L6.37158125,89.5 C6.37158125,89.5 6.37158125,89.5 6.37158125,89.5 Z M89.5,173.375413 L89.5,179 L89.5,173.375413 C89.5,173.375413 89.5,173.375413 89.5,173.375413 Z"
          id="path-14"
        ></path>
        <filter
          x="-1.4%"
          y="-1.4%"
          width="102.8%"
          height="102.8%"
          filterUnits="objectBoundingBox"
          id="filter-15"
        >
          <feMorphology
            radius="1"
            operator="dilate"
            in="SourceAlpha"
            result="shadowSpreadOuter1"
          ></feMorphology>
          <feOffset
            dx="0"
            dy="0"
            in="shadowSpreadOuter1"
            result="shadowOffsetOuter1"
          ></feOffset>
          <feMorphology
            radius="1"
            operator="erode"
            in="SourceAlpha"
            result="shadowInner"
          ></feMorphology>
          <feOffset
            dx="0"
            dy="0"
            in="shadowInner"
            result="shadowInner"
          ></feOffset>
          <feComposite
            in="shadowOffsetOuter1"
            in2="shadowInner"
            operator="out"
            result="shadowOffsetOuter1"
          ></feComposite>
          <feGaussianBlur
            stdDeviation="0.5"
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          ></feGaussianBlur>
          <feColorMatrix
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.91643903 0"
            type="matrix"
            in="shadowBlurOuter1"
          ></feColorMatrix>
        </filter>
        <path
          d="M173.369922,89.5 L179,89.5 L173.369922,89.5 C173.369922,89.5 173.369922,89.5 173.369922,89.5 Z M89.5,6.37702403 C89.5,6.37702403 89.5,6.37702403 89.5,6.37702403 L89.5,9.9475983e-14 L89.5,6.37702403 Z M6.37158125,89.5 L2.84217094e-14,89.5 L6.37158125,89.5 C6.37158125,89.5 6.37158125,89.5 6.37158125,89.5 Z M89.5,173.375413 L89.5,179 L89.5,173.375413 C89.5,173.375413 89.5,173.375413 89.5,173.375413 Z"
          id="path-16"
        ></path>
        <filter
          x="-1.4%"
          y="-1.4%"
          width="102.8%"
          height="102.8%"
          filterUnits="objectBoundingBox"
          id="filter-17"
        >
          <feMorphology
            radius="1"
            operator="dilate"
            in="SourceAlpha"
            result="shadowSpreadOuter1"
          ></feMorphology>
          <feOffset
            dx="0"
            dy="0"
            in="shadowSpreadOuter1"
            result="shadowOffsetOuter1"
          ></feOffset>
          <feMorphology
            radius="1"
            operator="erode"
            in="SourceAlpha"
            result="shadowInner"
          ></feMorphology>
          <feOffset
            dx="0"
            dy="0"
            in="shadowInner"
            result="shadowInner"
          ></feOffset>
          <feComposite
            in="shadowOffsetOuter1"
            in2="shadowInner"
            operator="out"
            result="shadowOffsetOuter1"
          ></feComposite>
          <feGaussianBlur
            stdDeviation="0.5"
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          ></feGaussianBlur>
          <feColorMatrix
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.91643903 0"
            type="matrix"
            in="shadowBlurOuter1"
          ></feColorMatrix>
        </filter>
        <path
          d="M173.369922,89.5 L179,89.5 L173.369922,89.5 C173.369922,89.5 173.369922,89.5 173.369922,89.5 Z M89.5,6.37702403 C89.5,6.37702403 89.5,6.37702403 89.5,6.37702403 L89.5,9.9475983e-14 L89.5,6.37702403 Z M6.37158125,89.5 L2.84217094e-14,89.5 L6.37158125,89.5 C6.37158125,89.5 6.37158125,89.5 6.37158125,89.5 Z M89.5,173.375413 L89.5,179 L89.5,173.375413 C89.5,173.375413 89.5,173.375413 89.5,173.375413 Z"
          id="path-18"
        ></path>
        <filter
          x="-1.4%"
          y="-1.4%"
          width="102.8%"
          height="102.8%"
          filterUnits="objectBoundingBox"
          id="filter-19"
        >
          <feMorphology
            radius="1"
            operator="dilate"
            in="SourceAlpha"
            result="shadowSpreadOuter1"
          ></feMorphology>
          <feOffset
            dx="0"
            dy="0"
            in="shadowSpreadOuter1"
            result="shadowOffsetOuter1"
          ></feOffset>
          <feMorphology
            radius="1"
            operator="erode"
            in="SourceAlpha"
            result="shadowInner"
          ></feMorphology>
          <feOffset
            dx="0"
            dy="0"
            in="shadowInner"
            result="shadowInner"
          ></feOffset>
          <feComposite
            in="shadowOffsetOuter1"
            in2="shadowInner"
            operator="out"
            result="shadowOffsetOuter1"
          ></feComposite>
          <feGaussianBlur
            stdDeviation="0.5"
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          ></feGaussianBlur>
          <feColorMatrix
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.91643903 0"
            type="matrix"
            in="shadowBlurOuter1"
          ></feColorMatrix>
        </filter>
        <path
          d="M173.369922,89.5 L179,89.5 L173.369922,89.5 C173.369922,89.5 173.369922,89.5 173.369922,89.5 Z M89.5,6.37702403 C89.5,6.37702403 89.5,6.37702403 89.5,6.37702403 L89.5,9.9475983e-14 L89.5,6.37702403 Z M6.37158125,89.5 L2.84217094e-14,89.5 L6.37158125,89.5 C6.37158125,89.5 6.37158125,89.5 6.37158125,89.5 Z M89.5,173.375413 L89.5,179 L89.5,173.375413 C89.5,173.375413 89.5,173.375413 89.5,173.375413 Z"
          id="path-20"
        ></path>
        <filter
          x="-1.4%"
          y="-1.4%"
          width="102.8%"
          height="102.8%"
          filterUnits="objectBoundingBox"
          id="filter-21"
        >
          <feMorphology
            radius="1"
            operator="dilate"
            in="SourceAlpha"
            result="shadowSpreadOuter1"
          ></feMorphology>
          <feOffset
            dx="0"
            dy="0"
            in="shadowSpreadOuter1"
            result="shadowOffsetOuter1"
          ></feOffset>
          <feMorphology
            radius="1"
            operator="erode"
            in="SourceAlpha"
            result="shadowInner"
          ></feMorphology>
          <feOffset
            dx="0"
            dy="0"
            in="shadowInner"
            result="shadowInner"
          ></feOffset>
          <feComposite
            in="shadowOffsetOuter1"
            in2="shadowInner"
            operator="out"
            result="shadowOffsetOuter1"
          ></feComposite>
          <feGaussianBlur
            stdDeviation="0.5"
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          ></feGaussianBlur>
          <feColorMatrix
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.91643903 0"
            type="matrix"
            in="shadowBlurOuter1"
          ></feColorMatrix>
        </filter>
        <path
          d="M173.369922,89.5 L179,89.5 L173.369922,89.5 C173.369922,89.5 173.369922,89.5 173.369922,89.5 Z M89.5,6.37702403 C89.5,6.37702403 89.5,6.37702403 89.5,6.37702403 L89.5,9.9475983e-14 L89.5,6.37702403 Z M6.37158125,89.5 L2.84217094e-14,89.5 L6.37158125,89.5 C6.37158125,89.5 6.37158125,89.5 6.37158125,89.5 Z M89.5,173.375413 L89.5,179 L89.5,173.375413 C89.5,173.375413 89.5,173.375413 89.5,173.375413 Z"
          id="path-22"
        ></path>
        <filter
          x="-1.4%"
          y="-1.4%"
          width="102.8%"
          height="102.8%"
          filterUnits="objectBoundingBox"
          id="filter-23"
        >
          <feMorphology
            radius="1"
            operator="dilate"
            in="SourceAlpha"
            result="shadowSpreadOuter1"
          ></feMorphology>
          <feOffset
            dx="0"
            dy="0"
            in="shadowSpreadOuter1"
            result="shadowOffsetOuter1"
          ></feOffset>
          <feMorphology
            radius="1"
            operator="erode"
            in="SourceAlpha"
            result="shadowInner"
          ></feMorphology>
          <feOffset
            dx="0"
            dy="0"
            in="shadowInner"
            result="shadowInner"
          ></feOffset>
          <feComposite
            in="shadowOffsetOuter1"
            in2="shadowInner"
            operator="out"
            result="shadowOffsetOuter1"
          ></feComposite>
          <feGaussianBlur
            stdDeviation="0.5"
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          ></feGaussianBlur>
          <feColorMatrix
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.91643903 0"
            type="matrix"
            in="shadowBlurOuter1"
          ></feColorMatrix>
        </filter>
        <text
          id="text-24"
          fontFamily="Roboto"
          fontSize="32"
          fontWeight="bold"
          fill="#DADADA"
          fillOpacity="0.172940341"
        >
          <tspan x="0.469565217" y="42">
            {name}
          </tspan>
        </text>
        <filter
          x="-1.1%"
          y="-1.7%"
          width="102.3%"
          height="103.5%"
          filterUnits="objectBoundingBox"
          id="filter-25"
        >
          <feGaussianBlur
            stdDeviation="1"
            in="SourceAlpha"
            result="shadowBlurInner1"
          ></feGaussianBlur>
          <feOffset
            dx="0"
            dy="0"
            in="shadowBlurInner1"
            result="shadowOffsetInner1"
          ></feOffset>
          <feComposite
            in="shadowOffsetInner1"
            in2="SourceAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
            result="shadowInnerInner1"
          ></feComposite>
          <feColorMatrix
            values="0 0 0 0 0.647220335   0 0 0 0 0.638513446   0 0 0 0 0.638513446  0 0 0 0.606015079 0"
            type="matrix"
            in="shadowInnerInner1"
          ></feColorMatrix>
        </filter>
        <filter
          x="-1.1%"
          y="-1.7%"
          width="102.3%"
          height="103.5%"
          filterUnits="objectBoundingBox"
          id="filter-26"
        >
          <feGaussianBlur
            stdDeviation="1"
            in="SourceAlpha"
            result="shadowBlurInner1"
          ></feGaussianBlur>
          <feOffset
            dx="0"
            dy="0"
            in="shadowBlurInner1"
            result="shadowOffsetInner1"
          ></feOffset>
          <feComposite
            in="shadowOffsetInner1"
            in2="SourceAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
            result="shadowInnerInner1"
          ></feComposite>
          <feColorMatrix
            values="0 0 0 0 0.647220335   0 0 0 0 0.638513446   0 0 0 0 0.638513446  0 0 0 0.606015079 0"
            type="matrix"
            in="shadowInnerInner1"
          ></feColorMatrix>
        </filter>
        <text
          id="text-27"
          fontFamily="IRANSansWeb-Bold, IRANSansWeb"
          fontSize="16"
          fontWeight="bold"
          fill="#FFFFFF"
        >
          <tspan x="0.107826087" y="17">
            10
          </tspan>
        </text>
        <filter
          x="-10.0%"
          y="-3.7%"
          width="120.0%"
          height="114.8%"
          filterUnits="objectBoundingBox"
          id="filter-28"
        >
          <feOffset
            dx="0"
            dy="1"
            in="SourceAlpha"
            result="shadowOffsetOuter1"
          ></feOffset>
          <feGaussianBlur
            stdDeviation="0.5"
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          ></feGaussianBlur>
          <feColorMatrix
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0"
            type="matrix"
            in="shadowBlurOuter1"
          ></feColorMatrix>
        </filter>
        <text
          id="text-29"
          fontFamily="Roboto-Regular, Roboto"
          fontSize="12"
          fontWeight="normal"
          fill="#FFFFFF"
        >
          <tspan x="0.237304688" y="11">
            -120
          </tspan>
        </text>
        <filter
          x="-6.2%"
          y="-10.7%"
          width="112.5%"
          height="121.4%"
          filterUnits="objectBoundingBox"
          id="filter-30"
        >
          <feOffset
            dx="0"
            dy="0"
            in="SourceAlpha"
            result="shadowOffsetOuter1"
          ></feOffset>
          <feGaussianBlur
            stdDeviation="0.5"
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          ></feGaussianBlur>
          <feColorMatrix
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0"
            type="matrix"
            in="shadowBlurOuter1"
          ></feColorMatrix>
        </filter>
        <text
          id="text-31"
          fontFamily="Roboto-Regular, Roboto"
          fontSize="12"
          fontWeight="normal"
          fill="#FFFFFF"
        >
          <tspan x="74.3603516" y="12">
            +30
          </tspan>
        </text>
        <filter
          x="-7.1%"
          y="-10.7%"
          width="114.3%"
          height="121.4%"
          filterUnits="objectBoundingBox"
          id="filter-32"
        >
          <feOffset
            dx="0"
            dy="0"
            in="SourceAlpha"
            result="shadowOffsetOuter1"
          ></feOffset>
          <feGaussianBlur
            stdDeviation="0.5"
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          ></feGaussianBlur>
          <feColorMatrix
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0"
            type="matrix"
            in="shadowBlurOuter1"
          ></feColorMatrix>
        </filter>
        <linearGradient
          x1="0%"
          y1="50%"
          x2="92.8167348%"
          y2="50%"
          id="linearGradient-33"
        >
          <stop stopColor="#FF0000" offset="0%"></stop>
          <stop
            stopColor="#FF8383"
            stopOpacity="0.504944274"
            offset="50.3879856%"
          ></stop>
          <stop stopColor="#FF0000" offset="100%"></stop>
        </linearGradient>
        <text
          id="text-34"
          fontFamily="PTSerif-Caption, PT Serif Caption"
          fontSize="16"
          fontWeight="normal"
        >
          <tspan x="154.34" y="91">
            E
          </tspan>
        </text>
        <filter
          x="-13.6%"
          y="-7.5%"
          width="127.3%"
          height="115.0%"
          filterUnits="objectBoundingBox"
          id="filter-35"
        >
          <feOffset
            dx="0"
            dy="0"
            in="SourceAlpha"
            result="shadowOffsetOuter1"
          ></feOffset>
          <feGaussianBlur
            stdDeviation="0.5"
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          ></feGaussianBlur>
          <feColorMatrix
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.440887238 0"
            type="matrix"
            in="shadowBlurOuter1"
          ></feColorMatrix>
        </filter>
        <linearGradient
          x1="92.8167348%"
          y1="50%"
          x2="-1.11022302e-14%"
          y2="50%"
          id="linearGradient-36"
        >
          <stop stopColor="#FF0000" offset="0%"></stop>
          <stop
            stopColor="#FF8383"
            stopOpacity="0.504944274"
            offset="59.1597139%"
          ></stop>
          <stop stopColor="#FF0000" offset="100%"></stop>
        </linearGradient>
        <text
          id="text-37"
          fontFamily="PTSerif-Caption, PT Serif Caption"
          fontSize="14"
          fontWeight="normal"
        >
          <tspan x="0.108" y="90">
            W
          </tspan>
        </text>
        <filter
          x="-10.0%"
          y="-8.3%"
          width="120.0%"
          height="116.7%"
          filterUnits="objectBoundingBox"
          id="filter-38"
        >
          <feOffset
            dx="0"
            dy="0"
            in="SourceAlpha"
            result="shadowOffsetOuter1"
          ></feOffset>
          <feGaussianBlur
            stdDeviation="0.5"
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          ></feGaussianBlur>
          <feColorMatrix
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.440887238 0"
            type="matrix"
            in="shadowBlurOuter1"
          ></feColorMatrix>
        </filter>
        <linearGradient
          x1="46.4083674%"
          y1="96.4083674%"
          x2="46.4083674%"
          y2="3.59163258%"
          id="linearGradient-39"
        >
          <stop stopColor="#FF0000" offset="0%"></stop>
          <stop
            stopColor="#FF8383"
            stopOpacity="0.504944274"
            offset="46.8486064%"
          ></stop>
          <stop stopColor="#FF0000" offset="100%"></stop>
        </linearGradient>
        <text
          id="text-40"
          fontFamily="PTSerif-Caption, PT Serif Caption"
          fontSize="14"
          fontWeight="normal"
        >
          <tspan x="77.26" y="14">
            N
          </tspan>
        </text>
        <filter
          x="-12.5%"
          y="-8.3%"
          width="125.0%"
          height="116.7%"
          filterUnits="objectBoundingBox"
          id="filter-41"
        >
          <feOffset
            dx="0"
            dy="0"
            in="SourceAlpha"
            result="shadowOffsetOuter1"
          ></feOffset>
          <feGaussianBlur
            stdDeviation="0.5"
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          ></feGaussianBlur>
          <feColorMatrix
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.440887238 0"
            type="matrix"
            in="shadowBlurOuter1"
          ></feColorMatrix>
        </filter>
        <linearGradient
          x1="46.4083674%"
          y1="96.4083674%"
          x2="46.4083674%"
          y2="3.59163258%"
          id="linearGradient-42"
        >
          <stop stopColor="#FF0000" offset="0%"></stop>
          <stop
            stopColor="#FF8383"
            stopOpacity="0.504944274"
            offset="48.0943834%"
          ></stop>
          <stop stopColor="#FF0000" offset="100%"></stop>
        </linearGradient>
        <text
          id="text-43"
          fontFamily="PTSerif-Caption, PT Serif Caption"
          fontSize="14"
          fontWeight="normal"
        >
          <tspan x="78.328" y="167">
            S
          </tspan>
        </text>
        <filter
          x="-16.7%"
          y="-8.3%"
          width="133.3%"
          height="116.7%"
          filterUnits="objectBoundingBox"
          id="filter-44"
        >
          <feOffset
            dx="0"
            dy="0"
            in="SourceAlpha"
            result="shadowOffsetOuter1"
          ></feOffset>
          <feGaussianBlur
            stdDeviation="0.5"
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          ></feGaussianBlur>
          <feColorMatrix
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.440887238 0"
            type="matrix"
            in="shadowBlurOuter1"
          ></feColorMatrix>
        </filter>
      </defs>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Artboard" transform="translate(-50.000000, -64.000000)">
          <g id="gimbal" transform="translate(16.000000, 30.000000)">
            <g id="gim-plate">
              <g id="gimbal-plate" transform="translate(38.000000, 38.000000)">
                <g id="gim-shadow">
                  <use
                    fill="black"
                    fillOpacity="1"
                    filter="url(#filter-2)"
                    xlinkHref="#path-1"
                  ></use>
                  <use
                    stroke="#979797"
                    strokeWidth="1"
                    xlinkHref="#path-1"
                  ></use>
                </g>
                <circle
                  id="gim-O2"
                  stroke="#979797"
                  strokeWidth="0.5"
                  fill="url(#radialGradient-3)"
                  cx="88.5"
                  cy="88.5"
                  r="88.5"
                ></circle>
                <circle
                  id="gim-O1"
                  stroke="#EEEEEE"
                  strokeWidth="0.5"
                  fillOpacity="0.292613636"
                  fill="#D8D8D8"
                  cx="88.002809"
                  cy="88.997191"
                  r="67.1207865"
                ></circle>
              </g>
              <g
                id="gimbal-degrees"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <g id="g-cs1" transform="translate(36.629248, 36.623782)">
                  <g>
                    <use
                      fill="black"
                      fillOpacity="1"
                      filter="url(#filter-5)"
                      xlinkHref="#path-4"
                    ></use>
                    <use
                      stroke="#F6F6F6"
                      strokeWidth="2"
                      xlinkHref="#path-4"
                    ></use>
                  </g>
                </g>
                <g
                  id="g-cs1"
                  transform="translate(126.129248, 126.123782) rotate(10.000000) translate(-126.129248, -126.123782) translate(36.629248, 36.623782)"
                >
                  <g>
                    <use
                      fill="black"
                      fillOpacity="1"
                      filter="url(#filter-7)"
                      xlinkHref="#path-6"
                    ></use>
                    <use
                      stroke="#F6F6F6"
                      strokeWidth="2"
                      xlinkHref="#path-6"
                    ></use>
                  </g>
                </g>
                <g
                  id="g-cs1"
                  transform="translate(126.129248, 126.123782) rotate(20.000000) translate(-126.129248, -126.123782) translate(36.629248, 36.623782)"
                >
                  <g>
                    <use
                      fill="black"
                      fillOpacity="1"
                      filter="url(#filter-9)"
                      xlinkHref="#path-8"
                    ></use>
                    <use
                      stroke="#F6F6F6"
                      strokeWidth="2"
                      xlinkHref="#path-8"
                    ></use>
                  </g>
                </g>
                <g
                  id="g-cs1"
                  transform="translate(126.129248, 126.123782) rotate(30.000000) translate(-126.129248, -126.123782) translate(36.629248, 36.623782)"
                >
                  <g>
                    <use
                      fill="black"
                      fillOpacity="1"
                      filter="url(#filter-11)"
                      xlinkHref="#path-10"
                    ></use>
                    <use
                      stroke="#F6F6F6"
                      strokeWidth="2"
                      xlinkHref="#path-10"
                    ></use>
                  </g>
                </g>
                <g
                  id="g-cs1"
                  transform="translate(126.129248, 126.123782) rotate(40.000000) translate(-126.129248, -126.123782) translate(36.629248, 36.623782)"
                >
                  <g>
                    <use
                      fill="black"
                      fillOpacity="1"
                      filter="url(#filter-13)"
                      xlinkHref="#path-12"
                    ></use>
                    <use
                      stroke="#F6F6F6"
                      strokeWidth="2"
                      xlinkHref="#path-12"
                    ></use>
                  </g>
                </g>
                <g
                  id="g-cs1"
                  transform="translate(126.129248, 126.123782) rotate(50.000000) translate(-126.129248, -126.123782) translate(36.629248, 36.623782)"
                >
                  <g>
                    <use
                      fill="black"
                      fillOpacity="1"
                      filter="url(#filter-15)"
                      xlinkHref="#path-14"
                    ></use>
                    <use
                      stroke="#F6F6F6"
                      strokeWidth="2"
                      xlinkHref="#path-14"
                    ></use>
                  </g>
                </g>
                <g
                  id="g-cs1"
                  transform="translate(126.129248, 126.123782) rotate(60.000000) translate(-126.129248, -126.123782) translate(36.629248, 36.623782)"
                >
                  <g>
                    <use
                      fill="black"
                      fillOpacity="1"
                      filter="url(#filter-17)"
                      xlinkHref="#path-16"
                    ></use>
                    <use
                      stroke="#F6F6F6"
                      strokeWidth="2"
                      xlinkHref="#path-16"
                    ></use>
                  </g>
                </g>
                <g
                  id="g-cs1"
                  transform="translate(126.129248, 126.123782) rotate(70.000000) translate(-126.129248, -126.123782) translate(36.629248, 36.623782)"
                >
                  <g>
                    <use
                      fill="black"
                      fillOpacity="1"
                      filter="url(#filter-19)"
                      xlinkHref="#path-18"
                    ></use>
                    <use
                      stroke="#F6F6F6"
                      strokeWidth="2"
                      xlinkHref="#path-18"
                    ></use>
                  </g>
                </g>
                <g
                  id="g-cs1"
                  transform="translate(126.129248, 126.123782) rotate(80.000000) translate(-126.129248, -126.123782) translate(36.629248, 36.623782)"
                >
                  <g>
                    <use
                      fill="black"
                      fillOpacity="1"
                      filter="url(#filter-21)"
                      xlinkHref="#path-20"
                    ></use>
                    <use
                      stroke="#F6F6F6"
                      strokeWidth="2"
                      xlinkHref="#path-20"
                    ></use>
                  </g>
                </g>
                <g
                  id="g-cs1"
                  transform="translate(126.129248, 126.123782) rotate(90.000000) translate(-126.129248, -126.123782) translate(36.629248, 36.623782)"
                >
                  <g>
                    <use
                      fill="black"
                      fillOpacity="1"
                      filter="url(#filter-23)"
                      xlinkHref="#path-22"
                    ></use>
                    <use
                      stroke="#F6F6F6"
                      strokeWidth="2"
                      xlinkHref="#path-22"
                    ></use>
                  </g>
                </g>
              </g>
              <g
                id="gimbal-name"
                transform="translate(77.000000, 94.000000)"
                stroke="#979797"
                strokeWidth="0.3"
              >
                <g>
                  <use
                    fill="#DADADA"
                    fillOpacity="0.172940341"
                    strokeOpacity="1"
                    filter="url(#filter-25)"
                    xlinkHref="#text-24"
                  ></use>
                  <use
                    fill="#DADADA"
                    fillOpacity="0.172940341"
                    strokeOpacity="1"
                    filter="url(#filter-26)"
                    xlinkHref="#text-24"
                  ></use>
                  <use xlinkHref="#text-24"></use>
                </g>
              </g>
            </g>
            <g id="gim-range" transform="translate(79.000000, 135.000000)">
              <g
                id="gim-current"
                transform="translate(34.000000, 0.000000)"
                fill="#FFFFFF"
                fillOpacity="1"
              >
                <g id="current">
                  <use filter="url(#filter-28)" xlinkHref="#text-27"></use>
                  <use xlinkHref="#text-27"></use>
                </g>
              </g>
              <g transform="translate(0.000000, 16.000000)">
                <g id="gim-Min" fill="#FFFFFF" fillOpacity="1">
                  <use filter="url(#filter-30)" xlinkHref="#text-29"></use>
                  <use xlinkHref="#text-29"></use>
                </g>
                <path
                  id="Line"
                  d="M31.2222222,7.9 L67.7777778,7.9 L67.7777778,5.5 L72.7777778,8 L67.7777778,10.5 L67.7777778,8.1 L31.2222222,8.1 L31.2222222,10.5 L26.2222222,8 L31.2222222,5.5 L31.2222222,7.9 Z"
                  fill="#FF0000"
                  fillRule="nonzero"
                ></path>
                <g id="gim-Max" fill="#FFFFFF" fillOpacity="1">
                  <use filter="url(#filter-32)" xlinkHref="#text-31"></use>
                  <use xlinkHref="#text-31"></use>
                </g>
              </g>
            </g>
            {directions && (
              <g id="directions" transform="translate(44.000000, 41.000000)">
                <g id="E">
                  <use
                    fill="#ED0000"
                    fillOpacity="1"
                    filter="url(#filter-35)"
                    xlinkHref="#text-34"
                  ></use>
                  <use
                    fill="url(#linearGradient-33)"
                    fillRule="evenodd"
                    xlinkHref="#text-34"
                  ></use>
                  <use
                    fill="#ED0000"
                    fillOpacity="1"
                    xlinkHref="#text-34"
                  ></use>
                </g>
                <g id="W">
                  <use
                    fill="#ED0000"
                    fillOpacity="1"
                    filter="url(#filter-38)"
                    xlinkHref="#text-37"
                  ></use>
                  <use
                    fill="url(#linearGradient-36)"
                    fillRule="evenodd"
                    xlinkHref="#text-37"
                  ></use>
                  <use
                    fill="#ED0000"
                    fillOpacity="1"
                    xlinkHref="#text-37"
                  ></use>
                </g>
                <g id="N">
                  <use
                    fill="#ED0000"
                    fillOpacity="1"
                    filter="url(#filter-41)"
                    xlinkHref="#text-40"
                  ></use>
                  <use
                    fill="url(#linearGradient-39)"
                    fillRule="evenodd"
                    xlinkHref="#text-40"
                  ></use>
                  <use
                    fill="#ED0000"
                    fillOpacity="1"
                    xlinkHref="#text-40"
                  ></use>
                </g>
                <g id="S">
                  <use
                    fill="#ED0000"
                    fillOpacity="1"
                    filter="url(#filter-44)"
                    xlinkHref="#text-43"
                  ></use>
                  <use
                    fill="url(#linearGradient-42)"
                    fillRule="evenodd"
                    xlinkHref="#text-43"
                  ></use>
                  <use
                    fill="#ED0000"
                    fillOpacity="1"
                    xlinkHref="#text-43"
                  ></use>
                </g>
              </g>
            )}
          </g>
        </g>
      </g>
    </svg>
  );
};
